import { Blockchain } from './common'

export const BlockchainNames = {
  undefined: '',
  [Blockchain.Ethereum]: 'Ethereum',
  [Blockchain.Binance]: 'BNB Chain',
  [Blockchain.Polygon]: 'Polygon',
  [Blockchain.Fantom]: 'Fantom',
  [Blockchain.Arbitrum]: 'Arbitrum',
  [Blockchain.Optimism]: 'Optimism',
  [Blockchain.Base]: 'Base',
  [Blockchain.Tron]: 'Tron',
}

export const getBlockchainNameByChainId = (chainId?: number) => {
  switch (chainId) {
    case 1:
      return 'Ethereum'
    case 3:
      return 'Ropsten'
    case 42:
      return 'Kovan'
    case 4:
      return 'Rinkeby'
    case 11155111:
      return 'Ethereum Sepolia'
    case 56:
      return 'BNB Chain'
    case 97:
      return 'BNB Chain Testnet'
    case 137:
      return 'Polygon'
    case 80002:
      return 'Polygon Testnet'
    case 250:
      return 'Fantom'
    case 4002:
      return 'Fantom Testnet'
    case 42161:
      return 'Arbitrum'
    case 421614:
      return 'Arbitrum Sepolia'
    case 10:
      return 'Optimism'
    case 11155420:
      return 'OP Sepolia'
    case 8453:
      return 'Base'
    case 84532:
      return 'Base Sepolia'
  }
  return 'Not found'
}
